import Vuex from "vuex";
import Vue from 'vue'
import label from './labeladmin.js'
import menu from './menu.js'
import orderList from './orderList.js'
Vue.use(Vuex);
const store = new Vuex.Store({
  modules:{
    label,
    menu,
    orderList
  }    
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js